import axios from 'axios'
import { apiErrorHandler } from '@/core/helpers/api.helpers'

/**
 * Get assessment configs
 *
 * @returns {Promise<any>}
 */
export const fetchAssessmentConfigs = (data) => {
  return axios.get(`/api/v1/assessment-configs`)
    .then((response) => {
      return response.data.assessment_configs
    })
    .catch((error) => {
      throw apiErrorHandler(error)
    })
}

/**
 * Create assessment config
 *
 * @param {Integer} id
 * @param {Object} data
 * @returns {Promise<any>}
 */
export const createAssessmentConfig = (data) => {
  return axios.post(`/api/v1/assessment-configs`, data)
    .then((response) => {
      return response.data.assessment_config
    })
    .catch((error) => {
      throw apiErrorHandler(error)
    })
}

/**
 * Update assessment config
 *
 * @param {Integer} id
 * @param {Object} data
 * @returns {Promise<any>}
 */
export const updateAssessmentConfig = (id, data) => {
  return axios.put(`/api/v1/assessment-configs/${id}`, data)
    .then((response) => {
      return response.data.assessment_config
    })
    .catch((error) => {
      throw apiErrorHandler(error)
    })
}

/**
 * Delete assessment config
 *
 * @param {Integer} id
 * @param {Object} data
 * @returns {Promise<any>}
 */
export const deleteAssessmentConfig = (id) => {
  return axios.delete(`/api/v1/assessment-configs/${id}`)
    .catch((error) => {
      throw apiErrorHandler(error)
    })
}

export default {
  fetchAssessmentConfigs,
  createAssessmentConfig,
  updateAssessmentConfig,
  deleteAssessmentConfig
}
